<ef-password-change-presenter
    [minPasswordLength]="minPasswordLength$ | async"
    [infoMessage]="infoMessage$ | async"
    [validateOldPasswordResponse]="validateOldPasswordResponse$ | async"
    [updateResponseStatusCode]="updatePasswordResponseStatusCode$ | async"
    [updateResponseMessage]="updatePasswordResponseMessage$ | async"
    (ValidateOldPassword)="onValidateOldPassword($event)"
    (UpdatePassword)="onUpdatePassword($event)"
    (Logout)="onLogout()"
></ef-password-change-presenter>
